import { useEffect, useState } from "react";
import styles from "./RegistrationName.module.css";

export function RegistrationName(props) {
    const [frontCount, setFrontCount] = useState(4)
    const [maxLength, setMaxLength] = useState(8)
  useEffect(() => {
    if (
      props.choosedOptions.categoryPlate.includes("standard") &&
      props.choosedOptions.registrationName.length >= maxLength
    ) {
      let regValidLegal =
        /^(?:[A-Z]{2}[0-9]{2}|[A-Z][0-9]{2})\s?[A-Z]{3}$/g.test(
          props.choosedOptions.registrationName
        );
      if (!regValidLegal) {
        props.onClick({
          isValid: regValidLegal,
          typePlate: "standard",
        });
      }
    } else if (
      props.choosedOptions.categoryPlate.includes("show") &&
      /[$&+,:;=?@#|'<>.^*()%!-]/g.test(props.choosedOptions.registrationName)
    ) {
      let regValidShow = !/[$&+,:;=?@#|'<>.^*()%!-]/g.test(
        props.choosedOptions.registrationName
      );
      if (regValidShow) {
        props.onClick({
          isValid: regValidShow,
          typePlate: "show",
        });
      }
    }

    if(/^[0-9]*$/.test(props.choosedOptions.registrationName.slice(1, 3)) && props.choosedOptions.registrationName.length > 1) {
        setMaxLength(7)
    } else {
        setMaxLength(8)
    }
  }, [props.choosedOptions]);

  useEffect(() => {
    if (props.choosedOptions.breakLine === "true") {
      props.choosedOptions.registrationNameSecond.length > 0
        ? props.updateRegisterName({
            registrationName:
              props.choosedOptions.registrationNameFirst +
              " " +
              props.choosedOptions.registrationNameSecond,
          })
        : props.updateRegisterName({
            registrationName: props.choosedOptions.registrationNameFirst,
          });
    }
  }, [props.choosedOptions.breakLine]);

  useEffect(() => {

  if (!props.choosedOptions.registrationNameFirst &&
      !props.choosedOptions.registrationNameSecond) {
    if (props.choosedOptions.categoryPlate.includes("standard")) {
      if (/^[0-9]*$/.test(props.choosedOptions.registrationName.slice(1, 3))) {
        props.updateRegisterName({
          registrationName: props.choosedOptions.registrationName
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9]/gi, "")
            .replace(/(.{3})/g, "$1 ")
            .trim()
            .toUpperCase(),
        });
      } else {
        props.updateRegisterName({
          registrationName: props.choosedOptions.registrationName
            .replace(/\s/g, "")
            .replace(/[^a-zA-Z0-9]/gi, "")
            .replace(/(.{4})/g, "$1 ")
            .trim()
            .toUpperCase(),
        });
      }
    }
    if (props.choosedOptions.registrationName.length > 0) {
      if (/^[0-9]*$/.test(props.choosedOptions.registrationName.slice(1, 3))) {
        props.updateRegisterName({
          registrationNameFirst: props.choosedOptions.registrationName.slice(
            0,
            3
          ),
          registrationNameSecond: props.choosedOptions.registrationName
            .slice(3)
            .trim(),
        });
      } else {
        props.updateRegisterName({
          registrationNameFirst: props.choosedOptions.registrationName.slice(
            0,
            4
          ),
          registrationNameSecond: props.choosedOptions.registrationName
            .slice(4)
            .trim(),
        });
      }
    }
  }
  }, []);

  const changeInputStyle = (e, pos) => {
    let filterInputValue;
    if (pos === "front") {
      if (props.choosedOptions.categoryPlate.includes("standard")) {
        if (
          maskOnInput(e.target.value.length, e.target.value, pos, "standard")
        ) {
          filterInputValue = e.target.value
            .replace(/[^a-zA-Z0-9]/gi, "")
            .replace(/(.{4})/g, "$1 ")
            .trim()
            .toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);
          props.onClick({
            isValid: false,
            typePlate: "typeStandard",
          });
        }
        props.choosedOptions.registrationNameSecond.length > 0
          ? props.updateRegisterName({
              registrationNameFirst: filterInputValue.trim(),
              registrationName:
                filterInputValue +
                " " +
                props.choosedOptions.registrationNameSecond,
            })
          : props.updateRegisterName({
              registrationNameFirst: filterInputValue.trim(),
              registrationName: filterInputValue,
            });
      } else {
        if (maskOnInput(e.target.value.length, e.target.value, pos, "show")) {
          filterInputValue = e.target.value.toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);
          props.onClick({
            isValid: false,
            typePlate: "typeShow",
          });
        }
        props.choosedOptions.registrationNameSecond.length > 0
          ? props.updateRegisterName({
              registrationNameFirst: filterInputValue.trim(),
              registrationName:
                filterInputValue +
                " " +
                props.choosedOptions.registrationNameSecond,
            })
          : props.updateRegisterName({
              registrationNameFirst: filterInputValue.trim(),
              registrationName: filterInputValue,
            });
      }
    } else if (pos === "second") {
      if (props.choosedOptions.categoryPlate.includes("standard")) {
        if (
          maskOnInput(e.target.value.length, e.target.value, pos, "standard")
        ) {
          filterInputValue = e.target.value
            .replace(/[^a-zA-Z0-9]/gi, "")
            .replace(/(.{4})/g, "$1 ")
            .trim()
            .toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);
          props.onClick({
            isValid: false,
            typePlate: "typeStandard",
          });
        }
        props.updateRegisterName({
          registrationNameSecond: filterInputValue,
          registrationName:
            props.choosedOptions.registrationNameFirst + " " + filterInputValue,
        });
      } else {
        if (maskOnInput(e.target.value.length, e.target.value, pos, "show")) {
          filterInputValue = e.target.value.toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);
          props.onClick({
            isValid: false,
            typePlate: "typeShow",
          });
        }
        props.updateRegisterName({
          registrationNameSecond: filterInputValue,
          registrationName:
            props.choosedOptions.registrationNameFirst + " " + filterInputValue,
        });
      }
    } else {
      if (props.choosedOptions.categoryPlate.includes("standard")) {
        if (
          maskOnInput(e.target.value.length, e.target.value, "all", "standard")
        ) {
          if (/^[0-9]*$/.test(e.target.value.slice(1, 3))) {
            filterInputValue = e.target.value
              .replace(/[^a-zA-Z0-9]/gi, "")
              .replace(/(.{3})/g, "$1 ")
              .trim()
              .toUpperCase();
          } else {
            filterInputValue = e.target.value
              .replace(/[^a-zA-Z0-9]/gi, "")
              .replace(/(.{4})/g, "$1 ")
              .trim()
              .toUpperCase();
          }
        } else {
          filterInputValue = e.target.value.slice(0, -1);
          props.onClick({
            isValid: false,
            typePlate: "typeStandard",
          });
        }
        props.updateRegisterName({
          registrationName: filterInputValue,
          registrationNameFirst: filterInputValue.slice(0, frontCount).trim(),
          registrationNameSecond: filterInputValue.slice(frontCount).trim(),
        });
      } else {
        if (maskOnInput(e.target.value.length, e.target.value, pos, "show")) {
          filterInputValue = e.target.value.toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);
          props.onClick({
            isValid: false,
            typePlate: "typeShow",
          });
        }
        if (props.choosedOptions.registrationName.indexOf(" ")) {
          const arrNames = props.choosedOptions.registrationName.split(" ");
          let firstName = arrNames.length > 0 ? arrNames[0] : "";
          let secondName = arrNames.length > 1 ? arrNames[1] : "";
          props.updateRegisterName({
            registrationName: filterInputValue,
            registrationNameFirst: firstName.trim(),
            registrationNameSecond: secondName,
          });
        } else {
          props.updateRegisterName({
            registrationName: filterInputValue,
            registrationNameFirst: filterInputValue.slice(0, 12).trim(),
            registrationNameSecond: filterInputValue.slice(12).trim(),
          });
        }
      }
    }
  };

  function maskOnInput(length, value, pos, category) {
    if (category.includes("standard")) {
      if (pos === "second") {
        if (length > 0 && length < 4) {
          return /^[A-Za-z\s]*$/.test(value);
        }
      } else {
        if (length >= 2 && /^[0-9]*$/.test(value.slice(1, 2))) {
            setFrontCount(3)
          if (length > 0 && length < 2) {
            return /^[A-Za-z\s]*$/.test(value);
          } else if (length >= 1 && length < 4) {
            return /^[0-9]*$/.test(value.slice(1, 3));
          } else if (length >= 4 && length < 8) {
            return (
              /^[A-Za-z\s]*$/.test(value.slice(3, 7)) &&
              /^[0-9]*$/.test(value.slice(1, 3))
            );
          }
        } else {
            setFrontCount(4)
          if (length > 0 && length < 3) {
            return /^[A-Za-z\s]*$/.test(value);
          } else if (length >= 3 && length < 5) {
            return /^[0-9]*$/.test(value.slice(2, 4));
          } else if (length >= 5 && length < 9) {
            return (
              /^[A-Za-z\s]*$/.test(value.slice(4, 8)) &&
              /^[0-9]*$/.test(value.slice(2, 4))
            );
          }
        }
      }
    } else {
      return /^[A-Za-z0-9\s]*$/.test(value);
    }
  }

  function isValidRegisterName(event) {
    event ? event.preventDefault() : false;
  }

  const checkPasteValue = (e, count, pos) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text").toUpperCase();
    if (pastedText.length < count) {
      return false;
    } else {
      if (props.choosedOptions.categoryPlate.includes("standard")) {
        if (pos === "first") {
          props.choosedOptions.registrationNameSecond.length > 0
            ? props.updateRegisterName({
                registrationNameFirst: pastedText.trim(),
                registrationName:
                  pastedText +
                  " " +
                  props.choosedOptions.registrationNameSecond,
              })
            : props.updateRegisterName({
                registrationNameFirst: pastedText.trim(),
                registrationName: pastedText,
              });
        } else if (pos === "second") {
          props.updateRegisterName({
            registrationNameSecond: pastedText,
            registrationName:
              props.choosedOptions.registrationNameFirst + " " + pastedText,
          });
        } else {
            if(/^[0-9]*$/.test(props.choosedOptions.registrationName.slice(1, 3))) {
                props.updateRegisterName({
                  registrationName: pastedText,
                  registrationNameFirst: pastedText.slice(0, 3).trim(),
                  registrationNameSecond: pastedText.slice(3).trim(),
                });

            } else {
                props.updateRegisterName({
                  registrationName: pastedText,
                  registrationNameFirst: pastedText.slice(0, frontCount).trim(),
                  registrationNameSecond: pastedText.slice(frontCount).trim(),
                });

            }
        }
      } else {
        if (pos === "first") {
          props.updateRegisterName({
            registrationNameFirst: pastedText.trim(),
            registrationName:
              pastedText + props.choosedOptions.registrationNameSecond,
          });
        } else if (pos === "second") {
          props.updateRegisterName({
            registrationNameSecond: pastedText,
            registrationName:
              props.choosedOptions.registrationNameFirst + pastedText,
          });
        } else {
          props.updateRegisterName({
            registrationName: pastedText,
            registrationNameFirst: pastedText.slice(0, 12).trim(),
            registrationNameSecond: pastedText.slice(12).trim(),
          });
        }
      }
    }
  };

  return (
    <>
      {props.choosedOptions.breakLine === "true" && (
        <>
          <form
            onSubmit={isValidRegisterName}
            className={styles["registration-name"] + " flex"}
          >
            <input
              onChange={(e) => changeInputStyle(e, "front")}
              className={styles["registration-name__input"]}
              type="text"
              maxLength={props.choosedOptions.categoryPlate.includes("show") ? 12 : frontCount}
              value={props.choosedOptions.registrationNameFirst}
              placeholder="ENTER TOP LINE REG"
              onPaste={(e) => checkPasteValue(e, frontCount, "first")}
              ref={props.inputRef}
              onBlur={() =>
                props.updateRegisterName({
                  registrationNameFirst:
                    props.choosedOptions.registrationNameFirst.trim(),
                  registrationName:
                    props.choosedOptions.registrationNameFirst.trim() +
                    " " +
                    props.choosedOptions.registrationNameSecond,
                })
              }
              onClick={() => props.isDefaultName(false)}
            />
            <button
              onClick={() => {
                props.addFocus();
              }}
              className={
                styles["registration-name__edit"] + " flex items-center"
              }
            >
              EDIT
            </button>
          </form>
          <form
            onSubmit={isValidRegisterName}
            className={styles["registration-name"] + " flex"}
          >
            <input
              onChange={(e) => changeInputStyle(e, "second")}
              className={styles["registration-name__input"]}
              type="text"
              maxLength={props.choosedOptions.categoryPlate.includes("show") ? 13 : 3}
              value={props.choosedOptions.registrationNameSecond}
              placeholder="ENTER BOTTOM LINE REG"
              onPaste={(e) => checkPasteValue(e, 3, "second")}
              onBlur={() =>
                props.updateRegisterName({
                  registrationNameSecond:
                    props.choosedOptions.registrationNameSecond.trim(),
                  registrationName:
                    props.choosedOptions.registrationNameFirst +
                    " " +
                    props.choosedOptions.registrationNameSecond.trim(),
                })
              }
              ref={props.inputRef}
              onClick={() => props.isDefaultName(false)}
            />
            <button
              onClick={() => {
                props.addFocus();
              }}
              className={
                styles["registration-name__edit"] + " flex items-center"
              }
            >
              EDIT
            </button>
          </form>
        </>
      )}
      {props.choosedOptions.breakLine === "false" && (
        <form
          onSubmit={isValidRegisterName}
          className={styles["registration-name"] + " flex"}
        >
          <input
            onClick={() => props.isDefaultName(false)}
            onChange={changeInputStyle}
            className={styles["registration-name__input"]}
            type="text"
            maxLength={props.choosedOptions.categoryPlate.includes("show") ? 25 : maxLength}
            value={props.choosedOptions.registrationName}
            placeholder="ENTER YOUR REG"
            ref={props.inputRef}
            onPaste={(e) => checkPasteValue(e, 7)}

          />
          <button
            onClick={() => {
              props.addFocus();
            }}
            className={styles["registration-name__edit"] + " flex items-center"}
          >
            EDIT
          </button>
        </form>
      )}
    </>
  );
}
